// Excel експортът на „Дневни отчети → Персонални".
//
// Редовете идват ФИЛТРИРАНИ и ПОДРЕДЕНИ от таблицата (`onFilteredRowsChange`),
// не суровият отговор: файлът повтаря екрана, включително филтъра по сервитьор
// в колоната. Сумите излизат като ЧИСЛА, за да се сумират в Excel.
//
// БЕЗ собствен времеви печат — `exportToExcel` вече лепи `_${stamp}`.

import dayjs from "dayjs";
import type { TFunction } from "i18next";

import { exportToExcel } from "../../../../utils/excelExport";
import { parseDecimal } from "../../../../components/dataTable";
import type { Report } from "../../../../api/reports";

type Options = {
  t: TFunction;
  /** Има ли платено извън в брой и карта — колоната следва таблицата. */
  showOther: boolean;
};

export const exportPersonalReports = (
  rows: readonly Report[],
  { t, showOther }: Options,
) => {
  const title = t("reportsPage.dailyReportsTitle");

  exportToExcel<Report>({
    filename: title,
    sheetName: t("reportsPage.personalReports"),
    columns: [
      {
        header: t("reportsPage.reportNumber"),
        value: (row) => row.report_number,
        width: 10,
      },
      {
        header: t("reportsPage.dailyWorkDay"),
        value: (row) => dayjs(row.report_date).format("DD.MM.YYYY"),
        width: 14,
      },
      {
        header: t("reportsPage.waiter"),
        value: (row) => row.user_name ?? "",
        width: 24,
      },
      {
        header: t("reportsPage.bills"),
        value: (row) => Number(row.total_bills_count ?? 0),
        width: 10,
      },
      {
        header: t("reportsPage.cashAmount"),
        value: (row) => parseDecimal(row.cash_amount),
        width: 14,
      },
      {
        header: t("reportsPage.cardAmount"),
        value: (row) => parseDecimal(row.card_amount),
        width: 14,
      },
      ...(showOther
        ? [
            {
              header: t("reportsPage.dailyOther"),
              value: (row: Report) => parseDecimal(row.other_amount),
              width: 14,
            },
          ]
        : []),
      {
        header: t("reportsPage.dailyColTotal"),
        value: (row) => parseDecimal(row.total_amount),
        width: 14,
      },
      {
        header: t("reportsPage.createdAt"),
        value: (row) => dayjs(row.created_at).format("DD.MM.YYYY HH:mm:ss"),
        width: 20,
      },
    ],
    rows: [...rows],
  });
};
